import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() text: string;
  @Input() info: string;
  @Input() expanded: boolean;
  @Output() expand = new EventEmitter();

  showExpand: boolean = false;

  // get showExpand(): boolean {
  //   return this.expand.observed;
  // }

  constructor() { }

  ngOnInit(): void {
    this.showExpand = this.expanded !== undefined;
  }

  emitExpand(event: any) {
    if (this.expanded === undefined) return;

    event.stopPropagation();
    this.expanded = !this.expanded;
    this.expand.emit(this.expanded);
  }

}
